export function getInputId(fieldId) {
  return `form-field-input-${fieldId}`;
}
export function getLabelId(fieldId) {
  return `form-field-label-${fieldId}`;
}
export function getDescriptionId(fieldId) {
  return `form-field-description-${fieldId}`;
}
export function getErrorId(fieldId) {
  return `form-field-error-${fieldId}`;
}
export function getAriaDescribedBy(errorId, descriptionId) {
  return `${errorId} ${descriptionId}`;
}
export function getErrorDataHook(target) {
  return `field-error-${target}`;
}
export function useFieldAttributes(fieldId) {
  const errorId = getErrorId(fieldId);
  const descriptionId = getDescriptionId(fieldId);
  return {
    inputId: getInputId(fieldId),
    labelId: getLabelId(fieldId),
    descriptionId,
    errorId,
    ariaDescribedBy: getAriaDescribedBy(errorId, descriptionId)
  };
}
//# sourceMappingURL=field-attributes.js.map